import { render, staticRenderFns } from "./NavContainer.vue?vue&type=template&id=20ffa31b"
import script from "./NavContainer.vue?vue&type=script&lang=js"
export * from "./NavContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports